const dateTransformer = (inputDate) => {
  const date = new Date(inputDate);
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  const outputDate = date.toLocaleDateString("es-ES", options);
  // returns date with following format: "24/01/2023"
  return outputDate;
};

export { dateTransformer };
